export default "__VITE_ASSET__DuoTwx2h__"